import { STATUS_BADGE_MAP } from "@/lib/constants";

export default function StatusBadge({ status }) {
  const v = STATUS_BADGE_MAP[status] || STATUS_BADGE_MAP.available;
  return (
    <span className="inline-flex items-center gap-1.5 px-2 py-1 border border-canvas-line text-[11px] font-mono uppercase tracking-wider text-ink">
      <span className={`w-1.5 h-1.5 ${v.dot}`} />
      {v.label}
    </span>
  );
}
